import { render, staticRenderFns } from "./OrderStatusMultiselect.vue?vue&type=template&id=9968bfb2&scoped=true&"
import script from "./OrderStatusMultiselect.vue?vue&type=script&lang=js&"
export * from "./OrderStatusMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9968bfb2",
  null
  
)

export default component.exports